var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('action-sidebar',{attrs:{"title":(_vm.subsidiaryName + " - " + (_vm.$route.meta.title)),"value":true},on:{"close-modal":_vm.closeModal}},[_c('accounting-period-form',{attrs:{"id":_vm.id},on:{"on-close":_vm.closeModal}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9e0f983e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/accounting-periods/page-accounting-period-edit.vue
// module id = 1376
// module chunks = 29